import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const FloatingLanguageButtons = styled.div`
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 50;
  display: flex;
  gap: 0.5rem;
`;

const LangButton = styled.button`
  ${tw`text-sm font-bold uppercase flex items-center justify-center`}
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  background-color: ${({ active }) => (active ? "#2c3e50" : "#1c1c1c")};
  color: ${({ active }) => (active ? "#ffffff" : "#cccccc")};
  box-shadow: ${({ active }) =>
    active
      ? "0 0 10px rgba(44, 62, 80, 0.8)"
      : "0 0 4px rgba(255, 255, 255, 0.1)"};
  transition: all 0.3s ease;

  &:hover {
    background-color: #34495e;
    color: #fff;
  }
`;

const LanguageSwitcher = ({ changeLanguage, activeLanguage }) => {
  return (
    <FloatingLanguageButtons>
      <LangButton
        onClick={() => changeLanguage("es")}
        active={activeLanguage === "es"}
      >
        ES
      </LangButton>
      <LangButton
        onClick={() => changeLanguage("en")}
        active={activeLanguage === "en"}
      >
        EN
      </LangButton>
    </FloatingLanguageButtons>
  );
};

export default LanguageSwitcher;